<template>
  <b-overlay variant="white" spinner-variant="primary" blur="0" opacity=".75" rounded="sm" :show="isSetOfCriteriaSaveLoading">
    <div>
      <b-row class="mx-2 my-2" v-if="studentEvaluate.objectGroupEvaluateCriterias">
        <div class="font-weight-bold">Thực hiện trả lời các câu hỏi dưới đây: </div>
      </b-row>
      <div v-if="studentEvaluate.objectGroupEvaluateCriterias">
        <div v-for="(item, index) in studentEvaluate.objectGroupEvaluateCriterias" :key="index" class="mx-3">
          <b-row v-if="item.criteriaType === 1">
            <b-col cols="12" md="12">
              <b-form-group :label-for="item.name">
                <template v-slot:label>
                  {{ (index + 1) + ". " + item.name }} <span class="text-danger">*</span>
                </template>
                <vue-slider v-model="item.point" direction="ltr" :max="item.maxPoint" :min="1" style="width: 50%;" :disabled="true"
                  class="mx-1 my-2" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="item.criteriaType === 2 && item.multipleSelect !== 1">
            <b-col cols="12" md="12">
              <b-form-group :label-for="item.name">
                <template v-slot:label>
                  {{ (index + 1) + ". " + item.name }} <span class="text-danger" v-if="item.required">*</span>
                </template>
                <validation-provider #default="{ errors }" name="Câu hỏi này"
                  :rules="(item.required ? 'required' : '')">
                  <b-form-radio-group :id="'skin-radio-group_' + index" v-model="item.evaluationCriteriaOptionId[0]"
                    :name="'skin_' + index" :options="item.evaluationCriteriaOptions" disabled
                    class="custom-control-primary pl-2" :state="getElementState(errors)"
                    @input="checkDisabledSubmitButton" />
                  <small class="text-danger mx-1">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="item.criteriaType === 2 && item.multipleSelect === 1">
            <b-col cols="12" md="12">
              <b-form-group :label-for="item.name">
                <template v-slot:label>
                  {{ (index + 1) + ". " + item.name }} <span class="text-danger" v-if="item.required">*</span>
                </template>
                <validation-provider #default="{ errors }" name="Câu hỏi này"
                  :rules="(item.required ? 'required' : '')">
                  <b-form-checkbox-group :id="'skin2-radio-group_' + index" v-model="item.evaluationCriteriaOptionId"
                    class="custom-control-primary pl-2" :options="item.evaluationCriteriaOptions" disabled
                    :state="getElementState(errors)" @input="checkDisabledSubmitButton" />
                  <small class="text-danger mx-1">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="item.criteriaType === 3">
            <b-col cols="12" md="12">
              <b-form-group :label-for="item.name">
                <template v-slot:label>
                  {{ (index + 1) + '. ' + item.name }} <span class="text-danger" v-if="item.required">*</span>
                </template>
                <validation-provider #default="{ errors }" name="Câu hỏi này"
                  :rules="(item.required ? 'required|' : '') + 'max:1000'">
                  <b-form-textarea :id="'question_' + index" placeholder="Nhập câu trả lời" rows="3"
                    v-model="item.content" :state="getElementState(errors)" class="mx-1 mt-2" readonly
                    @input="checkDisabledSubmitButton" />
                  <small class="text-danger mx-1">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </div>
      <div v-else>
        <b-row>
          <b-col cols="12" md="12">
            <div class="text-center my-2"><b>Không có câu hỏi khảo sát/đánh giá nào!</b></div>
          </b-col>
        </b-row>
      </div>
    </div>
  </b-overlay>
</template>

<script>
import {
  BButton,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BModal,
  BOverlay,
  BRow,
  BFormDatepicker,
  BFormTextarea,
  BCardHeader,
  BCardTitle,
  BFormRadioGroup,
  BFormCheckbox,
  BFormCheckboxGroup,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import vSelect from 'vue-select'
import { mapActions, mapGetters } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import * as events from 'events'
import { getUser } from '@/auth/utils'
import VueSlider from 'vue-slider-component'


export default {
  name: 'SetOfCriteriaSave',
  components: {
    BFormGroup,
    BFormInput,
    BModal,
    BForm,
    BOverlay,
    BFormInvalidFeedback,
    BButton,
    BRow,
    BCol,
    vSelect,
    BFormDatepicker,
    ValidationProvider,
    ValidationObserver,
    BFormTextarea,
    VueSlider,
    BCardHeader,
    BCardTitle,
    BFormRadioGroup,
    BFormCheckbox,
    BFormCheckboxGroup,
  },
  directives: {
    Ripple,
  },
  props: {
    setOfCriteriaObjectId: {
      type: Number,
      default: undefined,
    },
    accountId: {
      type: Number,
      default: undefined,
    },
  },
  data() {
    return {
      user: getUser(),
      isSetOfCriteriaSaveLoading: false,
      required,
      isCheckCriterias: true,
      isCheckCriteriaTypeSliders: true,
      isLoading: false,
      isDisabledSubmitButton: false,
    }
  },
  computed: {
    events() {
      return events
    },
    ...mapGetters({
      studentEvaluate: 'studentEvaluate/studentEvaluate'
    }),
    isCreated() {
      return this.studentEvaluate.id === null
    },
  },
  async created() {
    this.isSetOfCriteriaSaveLoading = true
    try {
      await this.getStudentEvaluate({
        accountId: this.accountId, organizationId: this.user.orgId, setOfCriteriaObjectId: this.setOfCriteriaObjectId
      })
      this.isDisabledSubmitButton = false
      for (let i = 0; i < this.studentEvaluate.objectGroupEvaluateCriterias.length; i++) {
        if (this.studentEvaluate.objectGroupEvaluateCriterias[i].criteriaType === 1 && this.studentEvaluate.objectGroupEvaluateCriterias[i].point === 0) {
          this.isDisabledSubmitButton = true
          break;
        }
        if (this.studentEvaluate.objectGroupEvaluateCriterias[i].criteriaType === 2 && this.studentEvaluate.objectGroupEvaluateCriterias[i].required === 1 && this.studentEvaluate.objectGroupEvaluateCriterias[i].evaluationCriteriaOptionId.length === 0) {
          this.isDisabledSubmitButton = true
          break;
        }
        if (this.studentEvaluate.objectGroupEvaluateCriterias[i].criteriaType === 3 && this.studentEvaluate.objectGroupEvaluateCriterias[i].required === 1 && (this.studentEvaluate.objectGroupEvaluateCriterias[i].content === '' || this.studentEvaluate.objectGroupEvaluateCriterias[i].content === null)) {
          this.isDisabledSubmitButton = true
          break;
        }
      }
    } catch (e) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: `[${e.code}] ${e.message}`,
          icon: 'XCircleIcon',
          variant: 'danger',
        },
      })
    } finally {
      this.isSetOfCriteriaSaveLoading = false
    }
  },
  methods: {
    ...mapActions({
      createStudentEvaluate: 'studentEvaluate/createStudentEvaluate',
      updateStudentEvaluate: 'studentEvaluate/updateStudentEvaluate',
      getStudentEvaluate: 'studentEvaluate/getStudentEvaluate'
    }),
    getElementState(errors) {
      return errors.length > 0 ? false : null
    },
    async onSave(type = null) {
      const valid = this.$refs
        .setOfCriteriaSaveModalRef
        .validate()
      if (valid) {
        this.isSetOfCriteriaSaveLoading = true
        try {
          const response = this.isCreated
            ? await this.createStudentEvaluate(this.studentEvaluate)
            : await this.updateStudentEvaluate(this.studentEvaluate)
          if (response) {
            const {
              isSuccessful,
              message,
            } = response
            if (isSuccessful) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: message,
                  icon: 'CheckIcon',
                  variant: 'success',
                },
              })
              if (type === 'hide') {
                this.$bvModal.hide('evaluateCommonSaveModal')
              }
              this.$emit('succeed')
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: message,
                  icon: 'XCircleIcon',
                  variant: 'danger',
                },
              })
            }
          }
        } catch (e) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `[${e.code}] ${e.message}`,
              icon: 'XCircleIcon',
              variant: 'danger',
            },
          })
        } finally {
          this.isSetOfCriteriaSaveLoading = false
        }
      }
    },
    showToast(title, icon, variant, autoHideDelay = 1000) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title,
          icon,
          variant,
          autoHideDelay,
        },
      })
    },
    checkDisabledSubmitButton() {
      this.isDisabledSubmitButton = false
      for (let i = 0; i < this.studentEvaluate.objectGroupEvaluateCriterias.length; i++) {
        if (this.studentEvaluate.objectGroupEvaluateCriterias[i].criteriaType === 1 && this.studentEvaluate.objectGroupEvaluateCriterias[i].point === 0) {
          this.isDisabledSubmitButton = true
          break;
        }
        if (this.studentEvaluate.objectGroupEvaluateCriterias[i].criteriaType === 2 && this.studentEvaluate.objectGroupEvaluateCriterias[i].required === 1 && this.studentEvaluate.objectGroupEvaluateCriterias[i].evaluationCriteriaOptionId.length === 0) {
          this.isDisabledSubmitButton = true
          break;
        }
        if (this.studentEvaluate.objectGroupEvaluateCriterias[i].criteriaType === 3 && this.studentEvaluate.objectGroupEvaluateCriterias[i].required === 1 && (this.studentEvaluate.objectGroupEvaluateCriterias[i].content === '' || this.studentEvaluate.objectGroupEvaluateCriterias[i].content === null)) {
          this.isDisabledSubmitButton = true
          break;
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  label {
    font-size: 1rem;
  }
}

#evaluateCreditClassSaveModal .vue-slider-handle-end {
  display: none;
  pointer-events: none;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '~@core/scss/vue/libs/vue-slider.scss';
</style>
